// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/mafia/action/MafiaActionScreen.css */

/* Возвращаем оверлей на весь экран */
.mafia-action-screen-container {
  position: fixed; /* Было absolute, меняем на fixed для надежности */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  z-index: 3000; /* Выше всего */
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.2s ease-out;
}

/* Карточка меню */
.mafia-action-card {
  width: 90%;
  max-width: 380px;
  max-height: 85vh;
  background-color: var(--tg-theme-bg-color, #ffffff);
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  animation: scaleIn 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.shot-menu-header {
  padding: 18px 20px;
  background-color: var(--tg-theme-secondary-bg-color, #f0f0f0);
  border-bottom: 1px solid rgba(0,0,0,0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.shot-menu-title {
  font-size: 20px;
  font-weight: 800;
  color: var(--tg-theme-text-color);
  display: flex;
  align-items: center;
  gap: 8px;
}

.shot-menu-subtitle {
  font-size: 13px;
  color: var(--tg-theme-hint-color);
  font-weight: 500;
}

.shot-menu-list {
  flex: 1 1;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow-y: auto;
  touch-action: pan-y !important;
}

/* Базовый элемент: убираем лишнюю прозрачность, делаем четким */
.player-item {
  display: flex;
  align-items: center;
  padding: 3px 3px;
  background-color: var(--tg-theme-bg-color);
  border: 2px solid transparent; /* Рамка прозрачная по дефолту */
  border-radius: 14px;
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;
  opacity: 1; /* Полная видимость */
  box-shadow: 0 1px 3px rgba(0,0,0,0.05); /* Легкая тень для объема */
}

.player-item:active { transform: scale(0.99); }

/* --- 1. СТИЛЬ МАФИИ (вернуть как было) --- */
.player-item.is-mafia {
  background-color: rgba(209, 78, 78, 0.08); /* Легкий красный фон */
  border-color: rgba(209, 78, 78, 0.15);     /* Легкая красная рамка всегда */
}

/* --- 2. ВЫДЕЛЕНИЕ (ТОЛЬКО ЕСЛИ Я ВЫБРАЛ) --- */
.player-item.selected {
  border-color: #d14e4e; /* Яркая красная рамка */
  background-color: rgba(209, 78, 78, 0.05);
  box-shadow: 0 4px 12px rgba(209, 78, 78, 0.15);
  z-index: 2;
}

/* --- 3. ОТКЛЮЧЕННЫЙ (Мертв или Детектив-селф) --- */
.player-item.disabled {
  opacity: 0.5; /* "Туман" */
  pointer-events: none; /* Нельзя кликнуть */
  background-color: rgba(0,0,0,0.02);
  box-shadow: none;
  border-color: transparent;
}

/* Иконка внутри выбранного элемента */
.player-item.selected .target-icon-container {
  background-color: #d14e4e;
  color: white;
}

/* --- ИСПРАВЛЕНИЕ 1: Вернуть размер и цвет иконок --- */
.target-icon-container {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background-color: var(--tg-theme-secondary-bg-color); /* Серый фон по умолчанию */
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s, color 0.2s;
  flex-shrink: 0;
  color: var(--tg-theme-hint-color); /* Серый цвет иконки */
}

.target-icon {
  font-size: 24px; /* Вернули крупный размер */
  transition: all 0.2s;
}

/* При выборе игрока - красим контейнер и иконку */
.player-item.selected .target-icon-container {
  background-color: #d14e4e; /* Красный фон */
  color: #ffffff; /* Белая иконка */
}

/* Старый размер бейджа */
.vote-count-badge {
  position: absolute;
  top: -12px;
  right: -12px;
  background-color: #d14e4e;
  color: white;
  font-size: 11px;
  font-weight: 800;
  width: 20px;
  height: 20px;
  padding: 0 2px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  border: 2px solid var(--tg-theme-bg-color);
}

.player-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.player-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--tg-theme-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.player-role-label {
  font-size: 11px;
  color: #d14e4e;
  font-weight: 800;
  text-transform: uppercase;
  margin-top: 2px;
  background: rgba(209, 78, 78, 0.1);
  padding: 2px 6px;
  border-radius: 6px;
  align-self: flex-start;
}

.actions-container {
  display: flex;
  gap: 8px;
  margin-right: 4px;
}

.action-btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background-color: var(--tg-theme-secondary-bg-color);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-theme-hint-color);
  cursor: pointer;
  transition: all 0.2s;
}

.action-btn-icon:hover {
  background-color: var(--tg-theme-button-color);
  color: white;
}

.action-btn-icon.active {
  background-color: #000000;
  color: #ffffff;
  border: 1px solid rgba(255,255,255,0.2);
}

.shot-menu-footer {
  padding: 12px 12px;
  border-top: 1px solid rgba(0,0,0,0.05);
  background-color: var(--tg-theme-bg-color);
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.back-btn {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background-color: var(--tg-theme-secondary-bg-color);
  color: var(--tg-theme-text-color);
  border: none;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.finish-btn {
  flex: 1 1;
  height: 52px;
  border-radius: 16px;
  background-color: #d14e4e;
  color: white;
  font-size: 17px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  opacity: 0.5;
  transition: all 0.2s;
  pointer-events: none;
}

.finish-btn.active {
  opacity: 1;
  pointer-events: auto;
  box-shadow: 0 4px 15px rgba(209, 78, 78, 0.4);
}

.finish-btn.active:active { transform: scale(0.97); }
.finish-btn.pressed { background-color: #333; }

/* --- ИСПРАВЛЕНИЕ 2: Стили для табов действий (pill shape) --- */
.action-tabs {
  display: flex;
  gap: 8px;
  padding: 0 5px;
  overflow-x: auto;
  /* Скрываем скроллбар */
  scrollbar-width: none;
}
.action-tabs::-webkit-scrollbar { display: none; }

.action-tab-btn {
  border: none;
  background: transparent;
  padding: 6px 12px;
  border-radius: 20px; /* Закругленные пилюли */
  font-size: 14px;
  font-weight: 600;
  color: var(--tg-theme-hint-color);
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
}

/* Активный таб */
.action-tab-btn.active {
  background-color: var(--tg-theme-button-color, #2481cc);
  color: var(--tg-theme-button-text-color, #ffffff);
  box-shadow: 0 2px 8px rgba(36, 129, 204, 0.3);
}

/* Иконки внутри таба чуть меньше */
.action-tab-btn svg {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/mafia/action/MafiaActionScreen.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD,qCAAqC;AACrC;EACE,eAAe,EAAE,kDAAkD;EACnE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,aAAa,EAAE,eAAe;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,mDAAmD;EACnD,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,KAAK,mBAAmB,EAAE,UAAU,EAAE;AACxC;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,6BAA6B,EAAE,gCAAgC;EAC/D,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU,EAAE,qBAAqB;EACjC,sCAAsC,EAAE,2BAA2B;AACrE;;AAEA,sBAAsB,sBAAsB,EAAE;;AAE9C,8CAA8C;AAC9C;EACE,yCAAyC,EAAE,uBAAuB;EAClE,qCAAqC,MAAM,gCAAgC;AAC7E;;AAEA,gDAAgD;AAChD;EACE,qBAAqB,EAAE,wBAAwB;EAC/C,yCAAyC;EACzC,8CAA8C;EAC9C,UAAU;AACZ;;AAEA,qDAAqD;AACrD;EACE,YAAY,EAAE,YAAY;EAC1B,oBAAoB,EAAE,oBAAoB;EAC1C,kCAAkC;EAClC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oDAAoD,EAAE,2BAA2B;EACjF,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,6CAA6C;EAC7C,cAAc;EACd,iCAAiC,EAAE,sBAAsB;AAC3D;;AAEA;EACE,eAAe,EAAE,2BAA2B;EAC5C,oBAAoB;AACtB;;AAEA,kDAAkD;AAClD;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,iBAAiB;AACnC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,0CAA0C;EAC1C,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;EACpD,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA,4BAA4B,sBAAsB,EAAE;AACpD,sBAAsB,sBAAsB,EAAE;;AAE9C,iEAAiE;AACjE;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;AACA,kCAAkC,aAAa,EAAE;;AAEjD;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB,EAAE,wBAAwB;EAC7C,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,uDAAuD;EACvD,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA,mCAAmC;AACnC;EACE,eAAe;AACjB","sourcesContent":["/* src/components/mafia/action/MafiaActionScreen.css */\n\n/* Возвращаем оверлей на весь экран */\n.mafia-action-screen-container {\n  position: fixed; /* Было absolute, меняем на fixed для надежности */\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(2px);\n  z-index: 3000; /* Выше всего */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: fadeIn 0.2s ease-out;\n}\n\n/* Карточка меню */\n.mafia-action-card {\n  width: 90%;\n  max-width: 380px;\n  max-height: 85vh;\n  background-color: var(--tg-theme-bg-color, #ffffff);\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.4);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n  animation: scaleIn 0.25s cubic-bezier(0.18, 0.89, 0.32, 1.28);\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes scaleIn {\n  from { transform: scale(0.9); opacity: 0; }\n  to { transform: scale(1); opacity: 1; }\n}\n\n.shot-menu-header {\n  padding: 18px 20px;\n  background-color: var(--tg-theme-secondary-bg-color, #f0f0f0);\n  border-bottom: 1px solid rgba(0,0,0,0.05);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.shot-menu-title {\n  font-size: 20px;\n  font-weight: 800;\n  color: var(--tg-theme-text-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.shot-menu-subtitle {\n  font-size: 13px;\n  color: var(--tg-theme-hint-color);\n  font-weight: 500;\n}\n\n.shot-menu-list {\n  flex: 1;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow-y: auto;\n  touch-action: pan-y !important;\n}\n\n/* Базовый элемент: убираем лишнюю прозрачность, делаем четким */\n.player-item {\n  display: flex;\n  align-items: center;\n  padding: 3px 3px;\n  background-color: var(--tg-theme-bg-color);\n  border: 2px solid transparent; /* Рамка прозрачная по дефолту */\n  border-radius: 14px;\n  transition: all 0.2s ease;\n  position: relative;\n  cursor: pointer;\n  opacity: 1; /* Полная видимость */\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05); /* Легкая тень для объема */\n}\n\n.player-item:active { transform: scale(0.99); }\n\n/* --- 1. СТИЛЬ МАФИИ (вернуть как было) --- */\n.player-item.is-mafia {\n  background-color: rgba(209, 78, 78, 0.08); /* Легкий красный фон */\n  border-color: rgba(209, 78, 78, 0.15);     /* Легкая красная рамка всегда */\n}\n\n/* --- 2. ВЫДЕЛЕНИЕ (ТОЛЬКО ЕСЛИ Я ВЫБРАЛ) --- */\n.player-item.selected {\n  border-color: #d14e4e; /* Яркая красная рамка */\n  background-color: rgba(209, 78, 78, 0.05);\n  box-shadow: 0 4px 12px rgba(209, 78, 78, 0.15);\n  z-index: 2;\n}\n\n/* --- 3. ОТКЛЮЧЕННЫЙ (Мертв или Детектив-селф) --- */\n.player-item.disabled {\n  opacity: 0.5; /* \"Туман\" */\n  pointer-events: none; /* Нельзя кликнуть */\n  background-color: rgba(0,0,0,0.02);\n  box-shadow: none;\n  border-color: transparent;\n}\n\n/* Иконка внутри выбранного элемента */\n.player-item.selected .target-icon-container {\n  background-color: #d14e4e;\n  color: white;\n}\n\n/* --- ИСПРАВЛЕНИЕ 1: Вернуть размер и цвет иконок --- */\n.target-icon-container {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background-color: var(--tg-theme-secondary-bg-color); /* Серый фон по умолчанию */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.2s, color 0.2s;\n  flex-shrink: 0;\n  color: var(--tg-theme-hint-color); /* Серый цвет иконки */\n}\n\n.target-icon {\n  font-size: 24px; /* Вернули крупный размер */\n  transition: all 0.2s;\n}\n\n/* При выборе игрока - красим контейнер и иконку */\n.player-item.selected .target-icon-container {\n  background-color: #d14e4e; /* Красный фон */\n  color: #ffffff; /* Белая иконка */\n}\n\n/* Старый размер бейджа */\n.vote-count-badge {\n  position: absolute;\n  top: -12px;\n  right: -12px;\n  background-color: #d14e4e;\n  color: white;\n  font-size: 11px;\n  font-weight: 800;\n  width: 20px;\n  height: 20px;\n  padding: 0 2px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\n  border: 2px solid var(--tg-theme-bg-color);\n}\n\n.player-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.player-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--tg-theme-text-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.player-role-label {\n  font-size: 11px;\n  color: #d14e4e;\n  font-weight: 800;\n  text-transform: uppercase;\n  margin-top: 2px;\n  background: rgba(209, 78, 78, 0.1);\n  padding: 2px 6px;\n  border-radius: 6px;\n  align-self: flex-start;\n}\n\n.actions-container {\n  display: flex;\n  gap: 8px;\n  margin-right: 4px;\n}\n\n.action-btn-icon {\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background-color: var(--tg-theme-secondary-bg-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-theme-hint-color);\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.action-btn-icon:hover {\n  background-color: var(--tg-theme-button-color);\n  color: white;\n}\n\n.action-btn-icon.active {\n  background-color: #000000;\n  color: #ffffff;\n  border: 1px solid rgba(255,255,255,0.2);\n}\n\n.shot-menu-footer {\n  padding: 12px 12px;\n  border-top: 1px solid rgba(0,0,0,0.05);\n  background-color: var(--tg-theme-bg-color);\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.back-btn {\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  background-color: var(--tg-theme-secondary-bg-color);\n  color: var(--tg-theme-text-color);\n  border: none;\n  font-size: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.finish-btn {\n  flex: 1;\n  height: 52px;\n  border-radius: 16px;\n  background-color: #d14e4e;\n  color: white;\n  font-size: 17px;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  opacity: 0.5;\n  transition: all 0.2s;\n  pointer-events: none;\n}\n\n.finish-btn.active {\n  opacity: 1;\n  pointer-events: auto;\n  box-shadow: 0 4px 15px rgba(209, 78, 78, 0.4);\n}\n\n.finish-btn.active:active { transform: scale(0.97); }\n.finish-btn.pressed { background-color: #333; }\n\n/* --- ИСПРАВЛЕНИЕ 2: Стили для табов действий (pill shape) --- */\n.action-tabs {\n  display: flex;\n  gap: 8px;\n  padding: 0 5px;\n  overflow-x: auto;\n  /* Скрываем скроллбар */\n  scrollbar-width: none;\n}\n.action-tabs::-webkit-scrollbar { display: none; }\n\n.action-tab-btn {\n  border: none;\n  background: transparent;\n  padding: 6px 12px;\n  border-radius: 20px; /* Закругленные пилюли */\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--tg-theme-hint-color);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid transparent;\n}\n\n/* Активный таб */\n.action-tab-btn.active {\n  background-color: var(--tg-theme-button-color, #2481cc);\n  color: var(--tg-theme-button-text-color, #ffffff);\n  box-shadow: 0 2px 8px rgba(36, 129, 204, 0.3);\n}\n\n/* Иконки внутри таба чуть меньше */\n.action-tab-btn svg {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
